import React from "react"
import PropTypes from "prop-types"
import "./TypeAhead.scss"
import { bem } from "../../helpers"
import BaseField from "../Field/Base"
import Input from "../Input/Input"
import Autosuggest from 'react-autosuggest';
import objectPath from "object-path"

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => {
  if (typeof suggestion === "object" && (suggestion.title || suggestion.label)) {
    return suggestion.title || suggestion.label
  } else {
    return suggestion
  }
}

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion, { query, isHighlighted }) => {
  //return "test"
  if (typeof suggestion === "object" && (suggestion.title || suggestion.label)) {
    suggestion = suggestion.title || suggestion.label
  }
  return suggestion; //<li className={bem("list", "item")}>{suggestion}</li>
}

export class TypeAhead extends BaseField {
  inputType="type-ahead"

  constructor(props) {
    super(props)
    this.state.suggestions=[]
  }


  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    this.onChange({target: {value: suggestion}})
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.props.getSuggestions ? this.props.getSuggestions(value) : this.getSuggestions(value) || []
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getSuggestions = value =>  {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : suggestions.filter( suggestion => {
      if (typeof suggestion === "object" && (suggestion.title || suggestion.label)) {
        suggestion = suggestion.title || suggestion.label
      }
      return suggestion.toLowerCase().slice(0, inputLength) === inputValue
    });
  }

  onSuggestionHighlighted = suggestion => {
    
  }

  renderInput = () => {
    const {
      id,
      placeholder,
      disabled,
      inputProps,
      containerProps
    } = this.props

    return (
      <Autosuggest
        id={id}
        theme={{
          container: bem("suggestions", "container", [], "", "m"),
          containerOpen: bem("suggestions", "container", ["open"], "", "m"),
          input: bem("list", "input"),
          inputOpen: bem("list", "input", ["open"], "", "m"),
          inputFocused:  bem("list", "input", ["focused"], "", "m"),
          itemsContainer:  bem("list", "items-container"),
          itemsContainerOpen:  bem("list", "items-container", ["open"], ["bordered", "rounded", "shadowed"].join(" "), "m"),
          itemsList: bem("list", "", ["type-none"]),
          item: bem("list", "item"),
          itemFirst:  bem("list", "item", ["first"], "", "m"),
          itemHighlighted:  bem("list", "item", ["highlighted"], "", "m"),
          sectionContainer:  bem("list", "section-container"),
          sectionContainerFirst:  bem("list", "section-container", ["first"], "", "m"),
          sectionTitle:  bem("list", "section-title"),
        }}
        className={bem("field", "type-ahead")}
        suggestions={this.state.suggestions}
        alwaysRenderSuggestions={true}
        renderInputComponent={this.renderChildInput}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={ this.props.getSuggestionValue || getSuggestionValue}
        renderSuggestion={this.props.renderSuggestion || renderSuggestion}
        onSuggestionHighlighted={this.onSuggestionHighlighted}
        inputProps={{
          placeholder,
          disabled,
          ...inputProps,
          onChange: (e) => this.onChange(e),
          value: this.value() || "",
          className: bem("field", "input")
        }}
        containerProps={{
          ...containerProps,
        }}
      />
    )
  }
}

TypeAhead.propTypes = {
  ...BaseField.propTypes,
  getSuggestions: PropTypes.func,
  getSuggestionValue: PropTypes.func,
  renderSuggestion: PropTypes.func,
  alwaysRenderSuggestions: PropTypes.bool,
  inputProps: PropTypes.object
}

TypeAhead.defaultProps = {
  inputProps: {
    placeholder: "search"
  },
  alwaysRenderSuggestions: false
}

export default TypeAhead
